import { Injectable } from '@angular/core'
import { config } from '../../config/appConfig'
import { HttpService } from './http.service'
import { Observable } from 'rxjs';
import { IUserBooksResponse, IUserBookWithChapterResponse, IUserChapterWithPagesResponse } from '../models/user';


enum ContentManagementEndPoints {
    books = "/books",            // Gets Published Books for End User Based On Subscription
    book = "/books",             // Gets Published Book With Published Chapters For User Based On Subscription
    pages = "/books/chapters"  // Gets Published Chapter with Published Pages for User Based On Subscription
}

@Injectable({
    providedIn: 'root',
})
export class ContentManagementService {
    httpService: HttpService = new HttpService(config.contentManagementServiceUrl);

    getBooks(pageNumber: number, pageSize: number): Observable<IUserBooksResponse> {
        const params = `?pageNumber=${pageNumber}&pageSize=${pageSize}`;
        return this.httpService.get(ContentManagementEndPoints.books + params);
    }

    getBook(bookId: string): Observable<IUserBookWithChapterResponse> {
        return this.httpService.get(ContentManagementEndPoints.book + "/" + bookId);
    }

    getPages(
        chapterId: string,
        layoutType: "Web" | "Android" | "Tablet",
        currentPageId?: string,
        count?: number,
        useTracking: boolean = true,
        languageCode?: string | null
    ): Observable<IUserChapterWithPagesResponse> {
        let url = `${ContentManagementEndPoints.pages}/${chapterId}`;
        const queryParams = new URLSearchParams();
        queryParams.append("layoutType", layoutType);

        if (currentPageId && currentPageId !== "") queryParams.append("currentPageId", currentPageId);
        if (count !== undefined) queryParams.append("count", count.toString());
        queryParams.append("useTracking", useTracking.toString());
        if (languageCode) queryParams.append("languageCode", languageCode);

        if (queryParams.toString()) {
            url += `?${queryParams.toString()}`;
        }

        return this.httpService.get(url);
    }
}
